import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-400 py-20 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-12 lg:gap-8">
          
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2.5 font-bold text-2xl tracking-tight text-white mb-6">
              <div className="w-8 h-8 bg-indigo-500 rounded flex items-center justify-center text-white">
                <SafeIcon icon={FiIcons.FiAnchor} className="text-lg" />
              </div>
              DeskHarbor
            </div>
            <p className="max-w-sm mb-8 text-sm leading-relaxed text-slate-500">
              DeskHarbor engineers workspace platforms for high-output professionals. Our mission is to eliminate physiological friction and cognitive load.
            </p>
            <div className="flex gap-4">
              {['Twitter', 'Instagram', 'Github', 'Linkedin'].map((social) => (
                <a key={social} href="#" className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
                  <SafeIcon icon={FiIcons[`Fi${social}`]} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-[10px] uppercase tracking-[0.2em] mb-6 font-mono">Registry</h4>
            <ul className="space-y-4 text-sm">
              {['Standing Desks', 'Task Seating', 'Cable Management', 'Lighting Control', 'Acoustic Panels'].map(item => (
                <li key={item}><a href="#" className="hover:text-indigo-400 transition-colors">{item}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-[10px] uppercase tracking-[0.2em] mb-6 font-mono">Operations</h4>
            <ul className="space-y-4 text-sm">
              {['Shipping Protocol', 'Returns & Logistics', 'Technical Support', 'Enterprise Solutions', 'Sustainability'].map(item => (
                <li key={item}><a href="#" className="hover:text-indigo-400 transition-colors">{item}</a></li>
              ))}
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h4 className="text-white font-bold text-[10px] uppercase tracking-[0.2em] mb-6 font-mono">Newsletter</h4>
            <p className="text-xs mb-4 text-slate-500">Updates on new workspace hardware.</p>
            <div className="flex gap-2">
              <input 
                type="email" 
                placeholder="Email address" 
                className="bg-slate-800 border-none rounded-lg px-3 py-2 text-xs w-full focus:ring-1 focus:ring-indigo-500" 
              />
              <button className="p-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors">
                <SafeIcon icon={FiIcons.FiArrowRight} />
              </button>
            </div>
          </div>

        </div>
        
        <div className="mt-20 pt-8 border-t border-slate-800/60 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-mono uppercase tracking-widest text-slate-600">
          <p>&copy; {new Date().getFullYear()} DeskHarbor. All Systems Nominal.</p>
          <p className="text-center" style={{ textTransform: 'none' }}>
            <span>Made by </span>
            <a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" style={{ textTransform: 'none' }}>DigLab.ai</a>
            <span> and </span>
            <a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" style={{ textTransform: 'none' }}>LingLinkAI.cn</a>
          </p>
          <div className="flex gap-8">
            <a href="#" className="hover:text-white transition-colors">Privacy_Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms_of_Service</a>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;